import Vue from 'vue'
import Vuex from 'vuex'
import { sync } from 'vuex-router-sync'
import createPersistedState from 'vuex-persistedstate'

import lesson from './modules/lesson'
import quiz from './modules/quiz'
import user from './modules/user'
import bottle from './modules/bottle'
import tasting from './modules/tasting'
import completion from './modules/completion'
import system from './modules/system'
import notification from './modules/notification'
import theme from './modules/theme'

import actions from './actions'
import router from '../router'

Vue.use(Vuex)

const store = new Vuex.Store({
  actions,
  modules: {
    lesson,
    quiz,
    user,
    tasting,
    bottle,
    completion,
    system,
    notification,
    theme
  },
  plugins: [
    createPersistedState({
      paths: [
        'lesson',
        'quiz',
        'user',
        'tasting',
        'bottle',
        'completion',
        'system.lastSyncDate',
        'theme'
      ],
      key: 'vuex_storage_key'
    })
  ]
})

sync(store, router)

export default store
